import { render, staticRenderFns } from "./DepartmentsManagement.vue?vue&type=template&id=17072bb1&scoped=true"
import script from "./DepartmentsManagement.vue?vue&type=script&lang=js"
export * from "./DepartmentsManagement.vue?vue&type=script&lang=js"
import style0 from "./DepartmentsManagement.vue?vue&type=style&index=0&id=17072bb1&prod&lang=scss"
import style1 from "./DepartmentsManagement.vue?vue&type=style&index=1&id=17072bb1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17072bb1",
  null
  
)

export default component.exports